import { Divider } from "antd";
import { truncateFloat } from "../../../../helpers/generalHelper";

const CardDetailTime = ({ lists = [] }) => {
	return (
		<div className="h-[192px] md:h-[112px] xl:h-[250px] flex flex-col ">
			<div className="w-full  flex justify-between">
				<p key={"Nombre testing"} className="h-fit w-[120px] text-center font-bold">
					Nombre testing
				</p>
				<p key={"Tiempo estimado"} className="h-fit w-[120px] text-center font-bold">
					Tiempo estimado
				</p>
				<p key={"No. Tareas"} className="h-fit w-[120px] text-center font-bold">
					No. Tareas
				</p>
				<p key={"totales trabajadas"} className="h-fit w-[120px] text-center font-bold">
					Horas totales trabajadas
				</p>
			</div>
			<Divider />
			<div className="w-full grow flex flex-col gap-4 overflow-auto">
				{lists.length > 0 &&
					lists.map((list, index) => {
						const values = Object.values({
							name: list.name,
                            timeEstimatedList: truncateFloat(list.timeEstimatedList),
							totalTask: list.totalTask,
                            timeSpentList: truncateFloat(list.timeSpentList),
						});
                        const valuesTesting = values.map((value, i2) => <p key={`${index}-${i2}-p-list`} className="  w-[127px] text-center">{value}</p>);

						return (
							<div key={values.toString() + index} className="w-full flex justify-between gap-4 items-center">
								{valuesTesting}
							</div>
						);
					})}
			</div>
		</div>
	);
};

export default CardDetailTime;
